import { Formio } from 'formiojs';
import { TagInputComponent } from './tag-input.component';

Formio.use({
  components: {
    taginput: TagInputComponent
  }
});
